<template>
  <div class="connected-credentials-card">
    <snack-bar class="header" :variant="headerVariant" :text="headerText">
      <template v-if="enableMenu" v-slot:secondary>
        <img class="toggle-menu" v-on:click.stop="openMenu"
             :src="require('@/assets/icons/menu-white.svg')">
      </template>
    </snack-bar>
    <div class="top-container">
      <source-logo :source-name="sourceName" :name="name" class="logo-container"/>
      <slot name="buttons"></slot>
    </div>
    <separator/>
    <expandable-connected-account-list
      :title="dropDownText"
      :disabled="disabled"
      :accounts="filteredAccounts"
      :source-type="sourceType"
    />
    <credentials-menu v-if="showMenu" :closeMenu="() => this.showMenu = false" :source="source"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import _ from 'lodash';
import SourceLogo from '@/base-components/onboarding/SourceLogo';
import ExpandableConnectedAccountList from '@/base-components/onboarding/ExpandableConnectedAccountList';
import Segment from '@/Segment';
import CredentialsMenu from '../credentials/credentials-list/CredentialsMenu';

export default {
  name: 'ConnectedCredentialsCard',
  components: {
    Separator: BaseUI.Separator,
    SnackBar: BaseUI.SnackBar,
    ExpandableConnectedAccountList,
    SourceLogo,
    CredentialsMenu,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  props: {
    name: { type: String, required: true },
    sourceName: { type: String, required: true },
    status: { type: String, required: true },
    sourceType: { type: String, required: true },
    accounts: { type: Array },
    enableMenu: { type: Boolean, required: false, default: false },
    source: { type: Object, required: false },
    enableCredentialsUpdate: { type: Boolean, required: false, default: false },
  },
  computed: {
    disabled() {
      return !this.isConnected;
    },
    headerVariant() {
      if (this.status === 'partiallyAuthorized') {
        return 'incomplete';
      }
      if (!this.isConnected) {
        return 'danger';
      }
      return 'success';
    },
    headerText() {
      if (this.status === 'partiallyAuthorized') {
        return 'ממתין לאישור שותפ.ה בבנק';
      }
      if (this.source && this.source.openBankingConsentId && this.status === 'passwordInvalid') {
        return 'דרוש חידוש הסכמה';
      }
      const sourceText = this.sourceType === 'bank' ? 'חשבון בנק' : 'חשבון אשראי';
      return `${sourceText} ${this.connectedOrDisconnectedText}`;
    },
    connectedOrDisconnectedText() {
      return this.isConnected ? 'מחובר' : 'לא מחובר';
    },
    isConnected() {
      return this.status !== 'passwordInvalid';
    },
    dropDownText() {
      return this.sourceType === 'bank' ? 'חשבונות כלולים בתזרים' : 'כרטיסים כלולים בתזרים';
    },
    filteredAccounts() {
      return _.filter(this.accounts, { sourceType: this.sourceType });
    },
  },
  methods: {
    openMenu() {
      Segment.trackUserInteraction('OpenCredentialsMenuClicked');
      this.showMenu = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';
.connected-credentials-card {
  position: relative;
  width: 100%;
  border: solid 1px $riseup_gray_0;
  border-radius: 10px;
  box-shadow: 0 5px 20px 0 rgba(148, 148, 148, 0.4);
  background-color: $riseup_white;

  .header {
    @include responsive-padding;
    display: flex;
    align-items: center;
    height: 40px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    padding-left: 15px;
    font-size: 14px;

    @media (min-width: 430px) {
      padding-left: 15px;
    }

    .toggle-menu {
      position: relative;
      padding: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
  .top-container {
    @include responsive-padding-top-bottom;
    @include responsive-padding;

    .button-container {
      .connect-credit-card-button {
        width: 100%;
      }
    }
  }
}
</style>
